import { type Enum } from '@webapp/infrastructure/types/Enum'
import {
  type QuickBooksExportStatus,
  QuickBooksExportStatuses,
} from '@webapp/platform/integrations/entities/enums/QuickBooksExportStatusEnum'

export const QuickBooksDesktopSettingsTabs = {
  GENERAL: 'general',
  IMPORT_EXPORT: 'import-export',
  ACTIVITY_LOG: 'activity-log',
  ERROR_LOG: 'error-log',
} as const

export type QuickBooksDesktopSettingsTab = Enum<
  typeof QuickBooksDesktopSettingsTabs
>

export const QuickBooksDesktopFieldMappingModels = {
  PO: 'po',
  BILLS: 'bills',
} as const

export type QuickBooksDesktopFieldMappingModel = Enum<
  typeof QuickBooksDesktopFieldMappingModels
>

export const QuickBooksDesktopImportStatuses = {
  UNIMPORTED: 'unimported',
  IMPORTED: 'imported',
} as const

export type QuickBooksDesktopImportStatus = Enum<
  typeof QuickBooksDesktopImportStatuses
>

export const QuickBooksDesktopExportResources = {
  PURCHASE_ORDERS: 'purchase-orders',
  ITEM_RECEIPTS: 'item-receipts',
  BILLS: 'bills',
} as const

export type QuickBooksDesktopExportResource = Enum<
  typeof QuickBooksDesktopExportResources
>

export interface QuickBooksDesktopSettingsPageParams {
  tab: QuickBooksDesktopSettingsTab
}

export interface QuickBooksDesktopFieldMappingPageParams {
  model: QuickBooksDesktopFieldMappingModel
}

export interface QuickBooksDesktopAccountsPageParams {
  status: QuickBooksDesktopImportStatus
}

export interface QuickBooksDesktopVendorsPageParams {
  status: QuickBooksDesktopImportStatus
}

export interface QuickBooksDesktopExportsPageParams {
  resource: QuickBooksDesktopExportResource
  status: QuickBooksExportStatus
}

const toRouteParam = (name: string, values: Record<string, string>) =>
  `:${name}(${Object.values(values).join('|')})`

/** react-router path params constrained to the values each route accepts. */
export const QuickBooksDesktopRouteParams = {
  SETTINGS_TAB: toRouteParam('tab', QuickBooksDesktopSettingsTabs),
  FIELD_MAPPING_MODEL: toRouteParam(
    'model',
    QuickBooksDesktopFieldMappingModels
  ),
  IMPORT_STATUS: toRouteParam('status', QuickBooksDesktopImportStatuses),
  EXPORT_RESOURCE: toRouteParam('resource', QuickBooksDesktopExportResources),
  EXPORT_STATUS: toRouteParam('status', QuickBooksExportStatuses),
} as const
